module.exports = __webpack_public_path__ + "static/media/pastel_thumb_even.455e0bf1.jpg";